import React, { useState } from 'react';
import '@ui5/webcomponents-icons/dist/overflow';
import {
  Button,
  ButtonDesign,
  ButtonPropTypes,
  Popover,
  PopoverPlacementType
} from '@ui5/webcomponents-react';
import { useStyles } from './OverflowMenu.jss';
import { createPortal } from 'react-dom';

export interface OverflowMenuProps extends ButtonPropTypes {
  children: React.ReactNode;
}

export const OverflowMenu: React.FC<OverflowMenuProps> = ({ children, ...props }) => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <>
      <Button
        {...props}
        id={props.id || 'overflow-button'}
        icon="overflow"
        design={ButtonDesign.Transparent}
        onClick={() => setMenuOpen(isMenuOpen ? false : true)}
      />
      {isMenuOpen &&
        createPortal(
          <Popover
            opener={props.id || 'overflow-button'}
            open={isMenuOpen}
            onBeforeClose={() => setMenuOpen(false)}
            hideArrow
            allowTargetOverlap
            placementType={PopoverPlacementType.Bottom}
            className={classes.popover}
            data-testid="overflow-menu-popover"
          >
            {children}
          </Popover>,
          document.body
        )}
    </>
  );
};
